import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import QuestionUploadImage from "../QuestionUploadImage/QuestionUploadImage";

function Questionaire(props) {

  const { promotionSettings, register, formState, resetField, trigger, setSavedSelectedImage, savedSelectedImage, setValue } = props;
  const requiredAge = promotionSettings?.age_limits || 18;

  const questions = promotionSettings.promotion_type.questions;
  // console.log(questions);
  const [maxChar, setMaxChar] = useState([]);
  const [charactersCounts, setCharactersCounts] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  const handleTextChange = (e, index) => {
    let text = e.target.value;

    if (text.startsWith(" ")) {
      text = text.replace(/^\s+/g, "");
      e.target.value = text;
    }

    const trimmedText = text.trim();

    const newTextValueLengths = [...charactersCounts];

    if (trimmedText !== "") {
      const textLength = text.length;
      newTextValueLengths[index] = maxChar[index] - textLength;
    } else {
      newTextValueLengths[index] = maxChar[index];
    }

    setCharactersCounts(newTextValueLengths);
  };

  useEffect(() => {
    if (questions && questions.length > 0) {
      const maxCharMapping = {};
      questions.forEach((question, index) => {
        if (question.answer_type === "best_answer") {
          maxCharMapping[index] = question.answer_character_amount;
        }
      });

      setMaxChar(maxCharMapping);
      setLoading(false);
    } else {
      setLoading(false);
    }

    // console.log("Max Char:", maxChar);
  }, [questions]);

  return (
    <>
      {questions.length > 0 && !loading &&
        <div className="promo-fields-group promo-fields__border-bottom">
          <div className="promo-fields">
            <div className="promo-field">
              <div className="pweu-question">
                {questions.map((question, index) => (<Fragment key={index}>
                  {!question.hidden && <div className="pweu-question">
                    <h5>
                      {question.question}
                      {question.answer_type === "data_field" && question.data_field.type === "date" 
                        ? ` (${t("Optional")})`
                        : '*'
                      }
                    </h5>
                    <p>{question.instruction}</p>
                    {question.image && <img src={question.image} alt="" />}
                    {question.answer_type === "single_choice" &&
                      <>
                        {maxChar[index]}
                        {question.answers?.map((answer, idx) => (
                          <label className="form-control" key={`single_choice_${index}_${idx}`} htmlFor={`answer-radio-${index + 1}-${idx + 1}`}>
                            <input type="radio" value={answer.answer} id={`answer-radio-${index + 1}-${idx + 1}`} name={`question_${index}`}  {...register(`question_${index + 1}`, { required: true })} />
                            <span className="radio-label">{answer.answer}</span>
                          </label>
                        ))}
                      </>
                    }
                    {question.answer_type === "multiple_choice" &&
                      <>
                        {question.answers?.map((answer, idx) => (
                          <label className="form-control" key={`multiple_choice_${index}_${idx}`} htmlFor={`answer-checkbox-${index + 1}-${idx + 1}`}>
                            <input type="checkbox" value={answer.answer} id={`answer-checkbox-${index + 1}-${idx + 1}`} name={`question_${index + 1}`}  {...register(`question_${index + 1}`, { required: true })} />
                            <span className="checkbox-label">{answer.answer}</span>
                          </label>
                        ))}
                        {(formState.errors[`question_${index + 1}`]?.type === "required" || formState.errors.receipt_number?.type === "validate") && (
                          <span className="error" >{t("Please fill out all required fields")}</span>
                        )}
                      </>
                    }
                    {question.answer_type === "best_answer" && (
                      <>
                        <textarea
                          onInput={(e) => handleTextChange(e, index)}
                          rows={5}
                          maxLength={maxChar[index]}
                          name={`question_text${index + 1}`}
                          {...register(`question_text_${index + 1}`, { required: true, validate: value => value.trim() !== "" })}
                          placeholder={t("Your Answer...")}
                          key={`best_answer_${index}`}
                        />
                        {maxChar[index] > 0 && (
                          <span className="char-count">
                            {charactersCounts[index] ?? maxChar[index]} {t("characters left")}
                          </span>
                        )}
                        {(formState.errors[`question_text_${index + 1}`]?.type === "required") && (
                          <span className="error">{t("Please fill out all required fields")}</span>
                        )}
                      </>
                    )}

                    {question.answer_type === "data_field" && (
                      <>
                        {question.data_field.type === "date" ? (
                          <>
                            <input
                              type="date"
                              min="1925-01-01"
                              className={`form-element ${formState.errors[`question_data_field_${question.data_field.id}`] ? 'error' : ''}`}
                              {...register(
                                `question_data_field_${question.data_field.id}`,
                                {
                                  required: false,
                                  validate: value => {
                                    if (!value) return true; // allow empty
                                    const selectedDate = new Date(value);
                                    const today = new Date();
                                    const age = today.getFullYear() - selectedDate.getFullYear();
                                    const m = today.getMonth() - selectedDate.getMonth();
                                    if (
                                      age > requiredAge ||
                                      (age === requiredAge && (m > 0 || (m === 0 && today.getDate() >= selectedDate.getDate())))
                                    ) {
                                      return true;
                                    }
                                    return t("minimumAgeMessage", { age: requiredAge, defaultValue: `You must be at least ${requiredAge} years old` });
                                  }
                                }
                              )}
                            />
                            {formState.errors[`question_data_field_${question.data_field.id}`] && (
                              <span className="error">
                                {formState.errors[`question_data_field_${question.data_field.id}`].message || t("Please fill out all required fields")}
                              </span>
                            )}
                          </>
                        ) : (
                          Object.entries(question.data_field.answers)
                            .sort(([keyA], [keyB]) => question.data_field.type === "bool" ? keyB.localeCompare(keyA) : 0) // Reverse only for bool
                            .map(([key, label]) => (
                              <label
                                className="form-control"
                                key={`data_field_${index}_${key}`}
                                htmlFor={`answer-input-${index}-${key}`}
                              >
                                <input
                                  type={
                                    question.data_field.type === "checkboxes"
                                      ? "checkbox"
                                      : question.data_field.type === "radios" || question.data_field.type === "bool"
                                        ? "radio" // bool behaves like radio
                                        : "checkbox" // default to checkbox
                                  }
                                  value={question.data_field.type === "bool" ? key : label} // bool stores numeric key, others store label
                                  id={`answer-input-${index}-${key}`}
                                  name={`question_data_field_${question.data_field.id}${question.data_field.type === "checkboxes" ? `_${key}` : ""}`}
                                  {...register(
                                    `question_data_field_${question.data_field.id}`,
                                    {
                                      required: true,
                                      validate: value => {
                                        // For checkboxes
                                        if (question.data_field.type === "checkboxes") {
                                          return value && value.length > 0;
                                        }
                                        // For radio buttons and bool type
                                        return value !== undefined;
                                      }
                                    }
                                  )}
                                />
                                <span className="input-label">{t(label)}</span>
                              </label>
                            ))
                        )}
                      </>
                    )}

                    {question.answer_type === "voting" && question.voting.answers && (
                      <>
                        <div className="voting" key={question.voting.id}>
                          {/* <h3>{question.question}</h3>
                                                  <p>{question.instruction}</p> */}
                          {Object.entries(question.voting.answers).map(([id, answer]) => (
                            <label
                              className="form-control"
                              key={`data_field__${question.voting.id}_${id}`}
                              htmlFor={`answer-input-${question.voting.id}-${id}`}
                            >
                              <input
                                type="radio"
                                value={answer.text}
                                id={`answer-input-${question.voting.id}-${id}`}
                                name={`question_${question.voting.id}`}
                                {...register(`question_voting_${question.voting.id}`, {
                                  required: true,
                                  validate: value => value !== undefined,
                                })}
                              />
                              <div className="input-label">
                                {!answer.image && <span>{answer.text}</span>}
                                {answer.image && (
                                  <picture>
                                    <img src={answer.image} alt={answer.text} />
                                  </picture>
                                )}
                              </div>
                            </label>
                          ))}
                        </div>
                      </>
                    )}

                    {question.answer_type === "image_upload" && (<>
                      <QuestionUploadImage register={register} formState={formState} resetField={resetField} trigger={trigger} imagePreview={true} setValue={setValue} inputName={"question_file_upload"} setSavedSelectedImage={setSavedSelectedImage} savedSelectedImage={savedSelectedImage} csrfToken={promotionSettings.csrfToken} questionID={index + 1} imageUploadInstruction={question.image_upload_instruction} />
                    </>)}

                  </div>}
                </Fragment>))}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Questionaire;
